import { useEffect, useState } from 'react';
import { AppIcon } from '../../components/AppIcon';
import { getSupabaseRuntimeIdentity } from '../../features/runtime/supabaseAdapter';
import type { RuntimeIdentityV1 } from '../../features/runtime/types';

export function StudentAccountPage() {
  const [identity, setIdentity] = useState<RuntimeIdentityV1 | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    void getSupabaseRuntimeIdentity().then((value) => { if (!cancelled) setIdentity(value); }).catch((cause) => { if (!cancelled) setError(cause instanceof Error ? cause.message : 'Profil belum dapat dimuat.'); });
    return () => { cancelled = true; };
  }, []);

  const student = identity?.student;
  return (
    <div className="stack production-page">
      <header className="production-page__heading"><div><span className="page-kicker">AKUN</span><h1>Profilku</h1><p className="muted">Informasi dasar yang digunakan BelajarKu untuk menyiapkan pengalaman belajarmu.</p></div></header>
      {error ? <div className="feedback feedback--error">{error}</div> : null}
      <section className="card account-hero">
        <div className="account-avatar">👧</div>
        <div className="account-hero__copy"><span className="page-kicker">MURID</span><h2>{student?.displayName || identity?.displayName || 'Murid BelajarKu'}</h2><p className="muted">{student?.studentCode ? `Kode murid ${student.studentCode}` : 'Profil belajar BelajarKu'}</p></div>
        <div className="account-status"><AppIcon name="shield" /><span><b>Riwayat aktif</b><small>Belajarmu tersimpan</small></span></div>
      </section>
      <section className="dashboard-grid">
        <article className="card dashboard-card"><div className="section-label"><AppIcon name="users" /> Profil</div><dl className="profile-list"><div><dt>Nama</dt><dd>{student?.displayName || identity?.displayName || '—'}</dd></div><div><dt>Kode murid</dt><dd>{student?.studentCode || '—'}</dd></div><div><dt>Status</dt><dd>{student?.status === 'active' ? 'Aktif belajar' : (student?.status || '—')}</dd></div></dl></article>
        <article className="card dashboard-card"><div className="section-label"><AppIcon name="shield" /> Penyimpanan belajar</div><p className="muted">Jawaban, perbaikan, waktu belajar, dan tulisan yang sudah dikirim akan tersimpan agar perjalanan belajarmu dapat dilihat kembali.</p></article>
      </section>
    </div>
  );
}
